import { Column, Row } from 'app/design/primitives/box';
import { ListingCardSkeleton } from './listing-card-skeleton';

interface ListingSkeletonsProps {
  horizontal?: boolean;
  count?: number;
}

export function ListingSkeletons({ horizontal = false, count = 5 }: ListingSkeletonsProps) {
  const items = Array.from({ length: count }, (_, i) => <ListingCardSkeleton key={i} />);
  return horizontal ? <Row gap="spacing.general.x4">{items}</Row> : <Column gap="spacing.general.x4">{items}</Column>;
}
